module.exports = __webpack_public_path__ + "img/icon-content-challenge.96d5a66b.svg";